import RouteLeaveConfirmation from './RouteLeaveConfirmation';

export default RouteLeaveConfirmation;
